import { AllureSupportingDocumentStateTypes, AllureSupportingDocumentActionTypes } from "./AllureSupportingDocument.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AllureSupportingDocumentStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AllureSupportingDocumentReducer = (
  state: AllureSupportingDocumentStateTypes = INITIAL_STATE,
  action: any
): AllureSupportingDocumentStateTypes => {
  switch (action.type) {
    case AllureSupportingDocumentActionTypes.FETCH_ALL_ALLURE_SUPPORTING_DOCUMENT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureSupportingDocumentActionTypes.FETCH_ALL_ALLURE_SUPPORTING_DOCUMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureSupportingDocumentActionTypes.FETCH_ALL_ALLURE_SUPPORTING_DOCUMENT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureSupportingDocumentActionTypes.FETCH_ALL_ALLURE_SUPPORTING_DOCUMENT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AllureSupportingDocumentActionTypes.FETCH_ONE_ALLURE_SUPPORTING_DOCUMENT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureSupportingDocumentActionTypes.FETCH_ONE_ALLURE_SUPPORTING_DOCUMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureSupportingDocumentActionTypes.FETCH_ONE_ALLURE_SUPPORTING_DOCUMENT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureSupportingDocumentActionTypes.FETCH_ONE_ALLURE_SUPPORTING_DOCUMENT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AllureSupportingDocumentReducer;
